import api from "@src/api";
import { Routes } from "@constants";

const getLatestPosts = () => {
  return api.get(Routes.getLatestPosts());
};

const getAllBlogPosts = (filter) => {
  return api.get(Routes.getAllBlogPosts(filter));
};
const getPublishedPosts = (filter) => {
  return api.get(Routes.getPublishedPosts(filter));
};
const getAllBlogCategories = () => {
  return api.get(Routes.getAllBlogCategories);
};
const getAllBlogTags = () => {
  return api.get(Routes.getAllBlogTags);
};
const getAllBlogAuthors = () => {
  return api.get(Routes.getAllBlogAuthors);
};
const getBlogPostBySlug = (slug) => {
  return api.get(Routes.getBlogPostBySlug(slug));
};

const logView = (slug) => {
  return api.get(Routes.logView(slug));
};

const createBlogPost = (post, token) => {
  return api.post(Routes.createBlogPost(token), post);
};

const editBlogPost = (post, token) => {
  return api.post(Routes.editBlogPost(token, post.slug), post);
};
const deleteBlogPost = (id) => {
  return api.del(Routes.deleteBlogPost(id));
};

const uploadBlogImages = async (formData) => {
  return await api.multiPart(Routes.uploadBlogImagesContent(), formData);
};

export default {
  getLatestPosts,
  createBlogPost,
  getAllBlogPosts,
  getAllBlogAuthors,
  getPublishedPosts,
  getBlogPostBySlug,
  logView,
  editBlogPost,
  getAllBlogCategories,
  getAllBlogTags,
  uploadBlogImages,
  deleteBlogPost,
};
